/* eslint-disable import/prefer-default-export */
export const prepareData = (formData: any) => {
  const ownerData = {
    user: {
      name: formData.name,
      lastname: formData.lastname,
      title: formData.title,
    },
  };

  const organizationData = {
    organization: {
      name: formData.schoolname,
      organization_configuration_attributes: {
        plan_days: formData.plan_days,
        activities_per_day: formData.activities_per_day,
        dap_initial_day: formData.dap_initial_day,
      },
    },
  };

  const centerData = {
    center: {
      name: formData.schoolname,
    },
  };

  const centerConfig = {
    center_configuration: {
      plan_days: formData.plan_days,
      activities_per_day: formData.activities_per_day,
      dap_initial_day: formData.dap_initial_day,
    },
  };

  return {
    ownerData,
    organizationData,
    centerData,
    centerConfig,
    schoolName: formData.schoolname || '',
  };
};
